// packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  containerStyle: {
    backgroundColor: '#ffff',
    borderRadius: 25,
    boxShadow: `${theme.colors.grey3} 0px 8px 20px 0px`,
    height: 90,
    marginTop: 20,
    paddingLeft: 30,
    paddingTop: 15
  },
  inputContainerStyle: {
    borderBottomWidth: 0,
    height: 30
  },
  labelStyle: {
    marginLeft: 5,
    fontWeight: 'normal'
  }
}));
